import { memo } from 'react';
import GridOrderedResources from '../common/GridOrderedResources';
import VertBash from './VertBash';

function GridBashOrdered(props) {
  return (
    <GridOrderedResources
      {...props}
      VerticalComponent={VertBash}
      showLoadingLegend={true}
      resourceType={'bash'}
      useResponsiveNearestHeader={true}
    />
  );
}

export default memo(GridBashOrdered);
